<template>
	<div style="margin:40px; margin-right:60px; font-family:Calibri, sans-serif;" v-if="deliveries && items" id="printJS-form" >
		<div class="row">
			<div class="columns small-7">
				<img class="logo" src="/img/logo.png" alt="Logo Reuzado">
			</div>
			<div class="columns small-5" v-if="deliveries.client.logo">
				<img class="logo" :src="deliveries.client.logo" alt="Logo klant">
			</div>
		</div>

		<div> &nbsp; </div>
		<div> &nbsp; </div>

		<h3 style="text-align:right;">PAKBON</h3>

		<div> &nbsp; </div>

		<div class="row">
			<div class="columns small-3">
				Bedrijfsnaam:
			</div>
			<div class="columns small-7">
				{{ deliveries.client.client_type_id == $constants.client.EINDGEBRUIKER ? deliveries.client.parent.name : deliveries.client.name }}
			</div>
		</div>

		<div class="row" v-if="deliveries.delivery_type_id === $constants.delivery.BULK_LEVERING || deliveries.contact">
			<div class="columns small-3">
				T.a.v.:
			</div>
			<div class="columns small-7">
				{{deliveries.contact}}
			</div>
		</div>
		
		<div class="row" v-else-if="deliveries.client.contacts[0]">
			<div class="columns small-3">
				T.a.v.:
			</div>
			<div class="columns small-7">
				{{ deliveries.client.contacts[0].first_name + " " + deliveries.client.contacts[0].last_name}}
			</div>
		</div>

		<div class="row" v-if="deliveries.contact_phone">
			<div class="columns small-3">
				Telefoonnummer:
			</div>
			<div class="columns small-7">
				{{deliveries.contact_phone}}
			</div>
		</div>



		<div class="row">
			<div class="columns small-3">
				Adres:
			</div>
			<div class="columns small-7">
				{{$filter.addressFirstLine(deliveries.address)}}
			</div>
		</div>
		<div class="row">
			<div class="columns small-3">
				Plaats:
			</div>
			<div class="columns small-7">
				{{$filter.addressSecondLine(deliveries.address)}}
			</div>
		</div>

		<div> &nbsp; </div>

		<div class="row">
			<div class="columns small-12">
				<strong>Datum: {{datetime(deliveries.finished) ?? datetime(deliveries.date)}} </strong>
			</div>
		</div>

		<div> &nbsp; </div>

		<hr>
			<div class="row">
				<div class="columns small-4">
				<strong>Uw referentie: </strong>
				</div>
				<div class="columns small-6">
					{{deliveries.your_reference}}
				</div>
			</div>
			<div class="row">
				<div class="columns small-4">
				<strong>Ordernummer: </strong>
				</div>
				<div class="columns small-6">
					{{deliveries.order_number}}
				</div>
			</div>
			<div class="row">
				<div class="columns small-4">
				<strong>Topdesk nummer: </strong>
				</div>
				<div class="columns small-6">
					{{deliveries.w_number}}
				</div>
			</div>
		<hr>

		<div> &nbsp; </div>

		<div> &nbsp; </div>

		<div v-if="productList">
			<div class="row">
				<div class="columns small-2">
					<span>Positie</span>
				</div>
				<div class="columns small-7">
					<span> Artikelcode Omschrijving</span>
				</div>
				<div class="columns small-3">
					<span> Lever hoeveelheid</span>
				</div>
			</div>

			<div v-for="(product, index) in productList" :key="product.id">
				<div class="row">
					<div class="columns small-2">
						<span>{{index + 1}}</span>
					</div>
					<div class="columns small-7">
						<div>{{product.article_number, product.name}}</div>
					</div>
					<div class="columns small-3">
						<span>{{product.arrived}}</span>
					</div>
				</div>
			</div>
			<div v-if="backorder">

				<div> &nbsp; </div>

				<div> &nbsp; </div>

				<h3>Backorder</h3>

				<div class="row">
					<div class="columns small-2">
						<span>Positie</span>
					</div>
					<div class="columns small-7">
						<span> Artikelcode Omschrijving</span>
					</div>
					<div class="columns small-3">
						<span> Lever hoeveelheid</span>
					</div>
				</div>

				<div>
					<div v-for="(product, count) in productList" :key="product.id">
						<div class="row" v-if="product.expected !== product.arrived">
							<div class="columns small-2">
								<span>{{count + 1}}</span>
							</div>
							<div class="columns small-7">
								<div>{{product.article_number}} {{product.name}}</div>
							</div>
							<div class="columns small-3">
								<span>{{product.expected - product.arrived}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else>
			<div class="row">
				<div class="columns small-2">
					<span>Positie</span>
				</div>
				<div class="columns small-7">
					<span> Artikelcode Omschrijving</span>
				</div>
				<div class="columns small-3">
					<span> Lever hoeveelheid</span>
				</div>
			</div>

			<div>
				<div v-for="(product, index) in delivery_items" :key="product.id">
					<div class="row">
						<div class="columns small-2">
							<span>{{index + 1}}</span>
						</div>
						<div class="columns small-7">
							<span>{{product.article_number}} {{product.name}}</span>
						</div>
						<div class="columns small-3">
							<span>1</span>
						</div>
					</div>
				</div>
			</div>
			<div v-if="backorder_items.length > 0">
				<h3>Backorder</h3>

				<div class="row">
					<div class="columns small-2">
						<span>Positie</span>
					</div>
					<div class="columns small-7">
						<span> Artikelcode Omschrijving</span>
					</div>
					<div class="columns small-3">
						<span> Lever hoeveelheid</span>
					</div>
				</div>
				<div>
					<div v-for="(product, count) in backorder_items" :key="product.id">
						<div class="row">
							<div class="columns small-2">
								<span>{{count + 1}}</span>
							</div>
							<div class="columns small-7">
								<span>{{product.article_number}} {{product.name}}</span>
							</div>
							<div class="columns small-3">
								<span>1</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="pickupItems.length > 0">
				<div> &nbsp; </div>

				<div> &nbsp; </div>

				<h3>Retour</h3>

				<div class="row">
					<div class="columns small-2">
						<span>Positie</span>
					</div>
					<div class="columns small-7">
						<span> Artikelcode Omschrijving</span>
					</div>
					<div class="columns small-3">
						<span> Lever hoeveelheid</span>
					</div>
				</div>
				<div>
					<div v-for="(product, count) in pickupItems" :key="product.id">
						<div class="row">
							<div class="columns small-2">
								<span>{{count + 1}}</span>
							</div>
							<div class="columns small-7">
								<span>{{product.article_number}} {{product.name}}</span>
							</div>
							<div class="columns small-3">
								<span>1</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div> &nbsp; </div>
		<div> &nbsp; </div>
		<div> &nbsp; </div>
		<div> &nbsp; </div>
		<div> &nbsp; </div>

		<div class="columns">
			<p> Handtekening voor ontvangst:</p>
			<p>Datum: </p>
			<p>Naam (in blokletters): </p>
		</div>

		<div class="pagebreak" style="clear: both; page-break-after: always;"> </div>

		<div>
			<h3>Serienummers</h3>

			<div class="row">
				<div class="columns small-2">
					<span>Positie</span>
				</div>
				<div class="columns small-7">
					<span>Artikelcode Omschrijving</span>
				</div>
				<div class="columns small-3">
					<span>Serienummer</span>
				</div>
			</div>
			<div>
				<div v-for="(item, count) in deliveries.items" :key="item.id">
					<div class="row" v-if="item.pivot.is_pickup === 0">
						<div class="columns small-2">
							<span>{{count + 1}}</span>
						</div>
						<div class="columns small-7">
							<span>{{item.amount ? item.amount + 'x' : ''}} {{item.product.name}}</span>
						</div>
						<div class="columns small-3">
							<span>{{item.serial}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div> &nbsp; </div>
		<div> &nbsp; </div>
		<div> &nbsp; </div>
		<div> &nbsp; </div>
		<div> &nbsp; </div>

		<div>
			<h3>Serienummers retour</h3>

			<div class="row">
				<div class="columns small-2">
					<span>Positie</span>
				</div>
				<div class="columns small-7">
					<span>Artikelcode Omschrijving</span>
				</div>
				<div class="columns small-3">
					<span>Serienummer</span>
				</div>
			</div>
			<div>
				<div v-for="(item, count) in deliveries.items" :key="item.id">
					<div class="row" v-if="item.pivot.is_pickup === 1">
						<div class="columns small-2">
							<span>{{count + 1}}</span>
						</div>
						<div class="columns small-7">
							<span>{{item.amount ? item.amount + 'x' : ''}} {{item.product.name}}</span>
						</div>
						<div class="columns small-3">
							<span>{{item.serial}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>

export default {
	data() {
		return {
			delivery_items: [],
			backorder_items: [],
			backorder: false,
		}
	},
	props:{
		deliveries: {
			required: true
		},
		items: {
			required: true
		},
		productList:{
			required: false
		},
		pickupItems: {
			required: false
		}
	},
	methods: {
		load(){
			if(this.productList)
			{
				for(const product of this.productList){
					this.backorder = product.arrived ==! product.expected ? true  : false;
				}

				const i = []
				for(const item of this.deliveries.items){
					if(item.product.product_group_id === 3){
						const existingItem = i.find(existing => existing.product_id === item.product_id);
						if (existingItem) {
							existingItem.amount += 1;
						} 
						else {
							item.amount = 1;
							i.push(item);
						}
					}
					else {
						i.push(item)
					}
				}
				this.deliveries.items = i;
			}
			else {
				for(const item of this.items)
				{
					if(item.pickup.item_id == null){
						this.backorder_items.push(item);
					}
					else {
						this.delivery_items.push(item);
					}
				}
			}
		},
		datetime(value){
			if ( typeof value == 'string' && value.trim() != '' ) {
				let date = new Date(value);

				if ( isNaN(date.getTime()) === false ) {
					return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric'})
				}
    		}
		},
	},
	mounted(){
		this.load();
	}
}
</script>
